import { gql } from "@apollo/client";
import moment from "moment";

const GET_DOCUMENTOS_CARGADOS = gql`
    query documentosCargadosAsistencial($idEvaluacion: Int!) {
            documentosCargadosAsistencial(idEvaluacion: $idEvaluacion) {
                success,
                error,
                valorEsperado {
                    idArchivo,
                    idTipoArchivoDocumento,
                    tipoArchivo,
                    titulo,
                    datos,
                    fechaAlta
                }
            }
        }
`;

export default GET_DOCUMENTOS_CARGADOS;

export const adaptDocumento = (documento) => {
  return {
    idArchivo: documento?.idArchivo,
    idTipoArchivoDocumento: documento?.idTipoArchivoDocumento,
    tipoArchivo: documento?.tipoArchivo,
    titulo: documento?.titulo,
    datos: documento?.datos,
    fechaAlta: moment(documento?.fechaAlta).format('DD/MM/yyyy')
  };
};

export const adaptDocumentosArray = (documentos) => {
  return structuredClone(documentos?.documentosCargadosAsistencial?.valorEsperado)?.
  map((documento) => adaptDocumento(documento));
};